import { Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { LabelField } from 'components'
import { Chip } from 'components/chips'
import { MichiganSOSBundleDto } from 'dtos'
import moment from 'moment'
import { formatAddress, formatDate } from 'utils'

interface MichiganSOSBundlesListCardProps {
  michiganSOSBundle: MichiganSOSBundleDto
}

export default function MichiganSOSBundleListCard({
  children,
  michiganSOSBundle
}: React.PropsWithChildren<MichiganSOSBundlesListCardProps>) {
  return (
    <>
      <Card>
        <CardContent>
          <Grid container direction='row' alignItems='flex-start' spacing={2}>
            <Grid item xs={12} md={4}>
              <Grid container spacing={2}>
                <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
                  <Grid item xs={4}>
                    {michiganSOSBundle.isLocked && <Chip variant={'red'}>BUNDLE LOCKED</Chip>}
                  </Grid>

                  <Grid item container xs={8} sm='auto'>
                    {children}
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Owner' value={michiganSOSBundle.michiganTitleOwnerName} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Count' value={michiganSOSBundle.vehicleCount} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField
                    label='Drop Off Date'
                    value={
                      michiganSOSBundle.dropOffDate
                        ? moment(`${moment(michiganSOSBundle.dropOffDate).format('MM/DD/yyyy')} 00:00:00`).format('M/D/yyyy')
                        : undefined
                    }
                  />{' '}
                </Grid>

                <Grid item xs={12}>
                  <LabelField
                    label='Branch Location'
                    value={
                      michiganSOSBundle.michiganSOSBranchCompanyAddress
                        ? formatAddress(michiganSOSBundle.michiganSOSBranchCompanyAddress)
                        : undefined
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <LabelField
                    label='Title Application Delivery Photo Uploaded'
                    value={
                      michiganSOSBundle.titleApplicationDeliveryPhotoUploadedDateTime
                        ? formatDate(michiganSOSBundle.titleApplicationDeliveryPhotoUploadedDateTime)
                        : '-'
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <LabelField
                    label='Bundle Completed'
                    value={
                      michiganSOSBundle.bundleCompletedDateTime
                        ? formatDate(michiganSOSBundle.bundleCompletedDateTime)
                        : undefined
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <LabelField
                    label='Created'
                    value={
                      michiganSOSBundle.createdDateTime
                        ? `${formatDate(michiganSOSBundle.createdDateTime)} by ${
                            michiganSOSBundle.createdByPerson
                              ? `${michiganSOSBundle.createdByPerson.firstName} ${
                                  michiganSOSBundle.createdByPerson.lastName || ''
                                }`.trim()
                              : '-'
                          }`
                        : '-'
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <LabelField
                    label='Modified'
                    value={
                      michiganSOSBundle.updatedDateTime
                        ? `${formatDate(michiganSOSBundle.updatedDateTime)} by ${
                            michiganSOSBundle.updatedByPerson
                              ? `${michiganSOSBundle.updatedByPerson.firstName} ${
                                  michiganSOSBundle.updatedByPerson.lastName || ''
                                }`.trim()
                              : '-'
                          }`
                        : '-'
                    }
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={8} container alignItems='flex-start'>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Last 6 Of VIN</TableCell>

                      <TableCell>Importer Stock#</TableCell>

                      <TableCell>Year</TableCell>

                      <TableCell>Make</TableCell>

                      <TableCell>Model</TableCell>

                      <TableCell>Vehicle Check-In Date</TableCell>

                      <TableCell>Application Packet Ready For MI SoS Bundle</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {michiganSOSBundle.vehicles?.map((vehicle, index) => (
                      <TableRow key={vehicle.vin} sx={{ backgroundColor: index % 2 === 0 ? '#FCFCFD' : 'white' }}>
                        <TableCell sx={{ borderBottom: index === (michiganSOSBundle.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.vin?.slice(-6)}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (michiganSOSBundle.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.importerStockNumber}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (michiganSOSBundle.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.year}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (michiganSOSBundle.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.make}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (michiganSOSBundle.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.model}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (michiganSOSBundle.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.vehicleCheckInDateTime ? formatDate(vehicle.vehicleCheckInDateTime) : ''}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (michiganSOSBundle.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.michiganTitleApplicationPacketReadyForMISoSBundleDateTime
                            ? formatDate(vehicle.michiganTitleApplicationPacketReadyForMISoSBundleDateTime)
                            : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
